import { render, staticRenderFns } from "./update-price.vue?vue&type=template&id=8ede9962&scoped=true&"
import script from "./update-price.vue?vue&type=script&lang=js&"
export * from "./update-price.vue?vue&type=script&lang=js&"
import style0 from "./update-price.vue?vue&type=style&index=0&id=8ede9962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ede9962",
  null
  
)

export default component.exports